import { render, staticRenderFns } from "./GruposSelect.vue?vue&type=template&id=13749490"
import script from "./GruposSelect.vue?vue&type=script&lang=js"
export * from "./GruposSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports